import React,{Component, createRef} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button, Form} from "semantic-ui-react";
import './style.scss';
import axios_event from "../../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../../axios/axios_api_services";
import * as common from "../../../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import DraggableList from 'react-draggable-list';
import * as actionCreator from "../../../../../../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import are_you_sure_icon from "../../../../../../../assets/img/sweet/question.svg";
import QuestionTemplate from "./QuestionTemplate";

let questionType = [
  {key: 1, text: 'Single', value: 'TEXT',},
  {key: 0, text: 'Multiple', value: 'MULTIPLE',}
]

class App extends Component {
  state = {
    data: [],
    questions: [
      // {
      //   id:0, question:"", isRequired: false, type: questionType[0].value, priority: 1, questions: 1,
      //   ansArr:[{id:0, answer:""}],
      // }
    ],
    useContainer: false,
  }
  _container = createRef();
  addNewRowHandler = () => {
    let {questions, subEventId} = this.props;

    let isNotSave = false;
    let body = [];
    questions.map((obj,index) => {
      if(obj.id > 0) body.push({"priorityLevel": index})
      if(obj.id === 0) isNotSave = true;
    })
    if(body.length === 0 || isNotSave) return common.notifyMessage("Some questions are not saved yet. Please check and try again.");

    questions.push({
      id:0, question:"", isRequired: false, type: questionType[0].value, priority: (questions.length + 1), questions: (questions.length + 1), key: questions.length, subEventId: subEventId,
      ansArr:[{id:0, answer:"", key: 0}]
    })
    // id:obj.subEventParticipantRegistrationQuestionId, question:obj.question, isRequired: obj.mandatory, type: obj.answerType, priority: obj.priorityLevel,
    //   ansArr:answers,  questions: subEventQuestions.length, subEventId: subEventId, key: index
    this.eventQuestionsHandler(questions);
    // this.setState({questions})
  }
  handleChange = (name,index,subIndex) => event => {
    let {questions} = this.props;
    if(name === 'ansArr') {
      questions[index].ansArr[subIndex].answer = event.target.value;
    }else{
      questions[index][name] = event.target.value;
    }
    // this.setState({questions});
    this.eventQuestionsHandler(questions);
  };
  dropDownChange = (name,index) => (event, {value}) => {
    let {questions} = this.props;
    questions[index][name] = value
    // this.setState({questions});
    this.eventQuestionsHandler(questions);
  };
  addAnsHandler = (index) =>{
    let {questions} = this.props;
    questions[index].ansArr.push({id:0, answer:"", key: questions[index].ansArr.length})
    // this.setState({questions});
    this.eventQuestionsHandler(questions);
  }
  removeAnsHandler = (index, subIndex, isUpdate, questionId, ansId) => {
    if(isUpdate) {
      swal({
        title: `Are you sure to remove this ${ansId === -1 ? `question`:'answer'}?`,
        icon: are_you_sure_icon, closeOnClickOutside: false,
        buttons: {cancel: 'Cancel', dangerMode: {text: "Ok", value: "action", className: "okay-btn"}},
      }).then((value) => {
        switch (value) {
          case "action":
            if(ansId === -1) this.removeQuestionHandler(questionId);
            if(ansId !== -1) this.removeQuestionAnswerHandler(questionId, ansId);
            break;
          default:
            break;
        }
      });
      return;
    }
    let {questions} = this.props;
    if(subIndex === -1) {
      questions.splice(index, 1);
    }else{
      questions[index].ansArr.splice(subIndex, 1);
    }
    // this.setState({questions});
    this.eventQuestionsHandler(questions);
  }
  tickHandler = (index) => {
    let {questions} = this.props;
    questions[index].isRequired = !questions[index].isRequired;
    this.eventQuestionsHandler(questions);
    // this.setState({questions});
  }
  eventQuestionsHandler = (questions) => {
    this.props.eventQuestionsHandler(questions);
    this.setState({updateTime: new Date().getTime()})
  }
  componentDidMount() {
    let {subEventQuestions, subEventId} = this.props;
    let questions = [{
      id:0, question:"", isRequired: false, type: questionType[0].value, priority: 1, questions: 1, subEventId: subEventId, key: 0,
      ansArr:[{id:0, answer:"", key: 0}],
    }];
    if(subEventQuestions && subEventQuestions.length > 0){
      questions = [];
      subEventQuestions.map((obj,index) => {
        let answers = [{id:0, answer:"", key:0}];
        if(obj.answers.length > 0) {
          answers = [];
          obj.answers.map((ans, ansIndex) => {
            answers.push({id: ans.subEventParticipantRegistrationAnswerId, answer:ans.answer, key: ansIndex})
          })
        }
        questions.push({
          id:obj.subEventParticipantRegistrationQuestionId, question:obj.question, isRequired: obj.mandatory, type: obj.answerType, priority: obj.priorityLevel,
          ansArr:answers,  questions: subEventQuestions.length, subEventId: subEventId, key: index
        })
      })
    }
    // this.setState({questions});
    this.eventQuestionsHandler(questions);
  }

  render() {
    let {questions} = this.props;
    let {useContainer} = this.state;
    return (
      <div className={'question-admin-wrapper'}>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap draggable-container-dhjer"}>
            <Card>
              <CardHeader>
                Questions
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  {/*{*/}
                  {/*  questions.map((obj,index)=>{*/}
                  {/*    return <Row key={index}>*/}
                  {/*      <Col md={12} className={'head-section'}>*/}
                  {/*        <p className={'q-number'}>{index+1}</p>*/}
                  {/*        /!*{questions.length > 1 ? <div className={'remove-ques'}>*!/*/}
                  {/*        /!*  <a onClick={()=>this.removeAnsHandler(index,-1)}>Remove Question</a>*!/*/}
                  {/*        /!*</div>:null}*!/*/}
                  {/*      </Col>*/}
                  {/*      <Col lg={obj.type === questionType[1].value ? 6 : 12}>*/}
                  {/*        <Row>*/}
                  {/*          <Col lg={obj.type === questionType[1].value ? 12 : 12}>*/}
                  {/*            <Form>*/}
                  {/*              <Form.Group widths='equal'>*/}
                  {/*                <TxtLbl required tagText={"Question"} placeholder={""} value={obj.question}*/}
                  {/*                        onChange={this.handleChange('question',index)}*/}
                  {/*                />*/}
                  {/*              </Form.Group>*/}
                  {/*            </Form>*/}
                  {/*          </Col>*/}
                  {/*          <Col lg={obj.type === questionType[1].value ? 7 : 4}>*/}
                  {/*            <Form>*/}
                  {/*              <Form.Group widths='equal'>*/}
                  {/*                <DrpDwn required tagText={"Question Type"} placeholder={""} value={obj.type} options={questionType}*/}
                  {/*                        onChange={this.dropDownChange('type',index)}*/}
                  {/*                />*/}
                  {/*              </Form.Group>*/}
                  {/*            </Form>*/}
                  {/*          </Col>*/}
                  {/*          <Col md={obj.type === questionType[1].value ? 5 : 2}>*/}
                  {/*            <p className={'none-opacity'}>_</p>*/}
                  {/*            <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}} label='Mandatory' checked={obj.isRequired}*/}
                  {/*                      onChange={()=>this.tickHandler(index)}*/}
                  {/*            />*/}
                  {/*          </Col>*/}
                  {/*        </Row>*/}
                  {/*      </Col>*/}
                  {/*      {obj.type === questionType[1].value ?<Col lg={6}>*/}
                  {/*        <Row>*/}
                  {/*          <Col lg={12}>*/}
                  {/*            <Form><div className={'required field undefined'}><label>Answers</label></div></Form>*/}
                  {/*          </Col>*/}
                  {/*          <Col md={12}>*/}
                  {/*            {*/}
                  {/*              obj.ansArr.map((ans,subIndex)=>{*/}
                  {/*                return <Form key={subIndex}>*/}
                  {/*                  <Form.Group widths='equal' className={"m-0 mb-3"}>*/}
                  {/*                    <div className={'input-wrapper'}>*/}
                  {/*                      <TxtLbl tagText={""} placeholder={""} value={ans.answer}*/}
                  {/*                              onChange={this.handleChange('ansArr',index, subIndex)}*/}
                  {/*                      />*/}
                  {/*                    </div>*/}
                  {/*                    <div className={'btn-wrapper'}>*/}
                  {/*                      {obj.ansArr.length > 1 ? <button className={'ui button rmv-btn'} onClick={()=>this.removeAnsHandler(index,subIndex, ans.id > 0, obj.id, ans.id)}>REMOVE</button>:null}*/}
                  {/*                      {(subIndex + 1) === obj.ansArr.length ? <button className={'ui button add-btn'} onClick={()=>this.addAnsHandler(index)}>ADD</button>:null}*/}
                  {/*                    </div>*/}
                  {/*                  </Form.Group>*/}
                  {/*                </Form>*/}
                  {/*              })}*/}
                  {/*          </Col>*/}
                  {/*        </Row>*/}
                  {/*      </Col>:null}*/}
                  {/*      <Col lg={12} className={'mt-3 question-main-btns'}>*/}
                  {/*        {questions.length > 1 ?*/}
                  {/*          <Button negative={true} onClick={() => this.removeAnsHandler(index,-1, obj.id > 0, obj.id, -1)}>{`Remove Question`}</Button>*/}
                  {/*          :null}*/}
                  {/*        <Button positive={true} onClick={() => this.validateQuestionHandler(obj)}>{`${obj.id === 0 ? `Save`:`Update`} Changes`}</Button>*/}
                  {/*      </Col>*/}
                  {/*      <Col lg={12}><hr/></Col>*/}
                  {/*    </Row>*/}
                  {/*  })*/}
                  {/*}*/}
                  <DraggableList
                    itemKey="id"
                    template={QuestionTemplate}
                    list={questions}
                    onMoveEnd={(newList) => this._onListChange(newList)}
                    container={() =>
                      useContainer ? this._container.current : document.body
                    }
                  />
                  <Row>
                    <Col lg={12} className={'add-new-questions'}>
                      <Button className="px-5" onClick={this.addNewRowHandler}>
                        <i aria-hidden="true" className="plus icon" />Add another new question
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  _onListChange(newList) {
    let body = [];
    let updatedList = [];
    let isNotSave = false;
    newList.map((obj,index) => {
      if(obj.id > 0) body.push({"subEventParticipantRegistrationQuestionId": obj.id, "priorityLevel": (index+1)})
      if(obj.id === 0) isNotSave = true;
    })
    if(!isNotSave) {
      newList.map((obj,index) => {
        updatedList.push({...obj, key: index})
      })
    }
    if(body.length === 0 || isNotSave) return common.notifyMessage("Some questions are not saved yet. Please check and try again.");
    this.eventQuestionsHandler(updatedList);

    let object = {
      subEventId: this.props.subEventId,
      priorityList: body
    }
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
    axios_event.patch(apiConfig.UPDATE_QUESTION_PRIORITY_LEVEL(this.props.usr_obj.corporates[0].corporateId), object, {headers: headers})
      .then(response => {
        common.notifyMessage(response.data.message, response.data.success ? 2 : 0);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this._onListChange(newList)
      })
  }
  validateQuestionsHandler = () => {
    let {questions} = this.state;
    let errList = [];
    if(questions.length > 0) {
      questions.map((obj,index) => {
        if(obj.question.trim() === "") errList.push({index: (index+1), subIndex:0, msg:"Question title cannot be empty"})
        if(obj.type === questionType[1].value) {
          if(obj.ansArr.length > 0) {
            obj.ansArr.map((ans,subIndex)=>{
              if(ans.answer.trim() === "") errList.push({index: index,subIndex:subIndex, msg:"Answer cannot be empty"})
            })
          }else{
            errList.push({index: index, subIndex:0, msg:"Please create one or more answers"})
          }
        }
      })
    }else{
      errList.push({index:0, subIndex:0, msg: "Questions cannot be empty"})
    }
    if(errList.length > 0) return common.notifyMessage("Missing some required fields!", 1);
    this.apiHandler();
  }
  validateQuestionHandler = (obj) => {
    let errList = [];
    if(obj.question.trim() === "") errList.push("Question cannot be empty")
    if(obj.type === questionType[1].value) {
      if(obj.ansArr.length > 0) {
        obj.ansArr.map(ans=>{
          if(ans.answer.trim() === "") errList.push("Answer cannot be empty")
        })
      }else{
        errList.push("Please create one or more answers")
      }
    }
    if(errList.length > 0) return common.notifyMessage("Missing some required fields!", 1);
    swal({
      title: `Are you sure to ${obj.id > 0 ? `update`:'save'} this question?`,
      icon: are_you_sure_icon, closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Ok", value: "action", className: "okay-btn"}},
    }).then((value) => {
      switch (value) {
        case "action":
          this.apiHandler(obj);
          break;
        default:
          break;
      }
    });
  }
  removeQuestionHandler = (questionId) => {
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
    this.props.spinnerHandler(true);
    axios_event.delete(apiConfig.DELETE_SUB_EVENT_PARTICIPANT_QUESTION(this.props.usr_obj.corporates[0].corporateId, questionId), {headers: headers})
      .then(response => {
        common.warningAlert(response.data.message, response.data.success ? 0 : 1);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.removeQuestionHandler(questionId)
      })
      .finally(() => this.props.spinnerHandler(false));
  }
  removeQuestionAnswerHandler = (questionId, answerId) => {
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
    this.props.spinnerHandler(true);
    axios_event.delete(apiConfig.DELETE_SUB_EVENT_PARTICIPANT_QUESTION_ANSWER(this.props.usr_obj.corporates[0].corporateId, questionId, answerId), {headers: headers})
      .then(response => {
        common.warningAlert(response.data.message, response.data.success ? 0 : 1);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.removeQuestionAnswerHandler(questionId, answerId)
      })
      .finally(() => this.props.spinnerHandler(false));
  }
  apiHandler = (obj) => {
    let {subEventId, usr_obj} = this.props;
    let answers = [];
    if(obj.type === questionType[1].value) obj.ansArr.map(ans=>answers.push(ans.answer.trim()));
    let body = {
      "question": obj.question.trim(),
      "answerType": obj.type,
      "isMandatory": obj.isRequired,
      "subEventId": subEventId,
      "answersList": answers
    }
    if(obj.id > 0) body.subEventParticipantRegistrationQuestionId = obj.id;
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
    this.props.spinnerHandler(true);
    axios_event[obj.id > 0 ? 'put':'post'](apiConfig.SAVE_SUB_EVENT_PARTICIPANT_QUESTION(usr_obj.corporates[0].corporateId), body, {headers: headers})
      .then(response => {
        common.warningAlert(response.data.message, response.data.success ? 0 : 1);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.apiHandler(obj)
      })
      .finally(() => this.props.spinnerHandler(false));
  }
}
const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
  questions: state.eventReducer.participantQuestions,
  updateTime: state.eventReducer.updateTime
});
const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    eventQuestionsHandler: (data) => dispatch(actionCreator.eventQuestionsHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
